import { NFT as ThirdWebNFT } from "thirdweb";
import { TokenStandart } from "../TokenStandart";

export class NFT {
    public readonly id: bigint;
    public readonly description: string;
    public readonly imageURL: string;
    public readonly name: string;
    public readonly owner: string;
    public readonly tokenURI: string;
    public readonly type: TokenStandart;

    public constructor(nft: ThirdWebNFT) {
        this.id = nft.id;
        this.description = nft.metadata?.description;
        this.imageURL = this.fixResourceUrl(nft.metadata?.image);
        this.name = nft.metadata?.name;
        this.owner = nft.owner;
        this.tokenURI = nft.tokenURI;
        this.type = nft.type as TokenStandart;
    }

    public toString(): string {
        return JSON.stringify(this, (_, v) => typeof v === 'bigint' ? v.toString() : v);
    }

    private fixResourceUrl(url: string): string {
        if (url == null || url.length === 0) {
            return null;
        }
        if (url.indexOf("ipfs") === -1) {
            return url;
        }
        return `https://cf-ipfs.com/ipfs/${url.substring(7)}`;
    }
}